import { PageLayout } from "@/shared/ui/layouts/PageLayout";
// import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
// import Typography from "@/shared/ui/Typography";
import * as React from "react";

import { PrivateBrokerConsultation } from "@/widgets/private_broker_consultation/ui";
import { useScrollToTop } from "@/shared/hooks/useScrollToTop";
import { MortgageCalculator } from "@/features/mortgage_calculator/MortgageCalculator";

export function MortgagePage() {
    
    const scrollToTop = useScrollToTop();
    const spaceRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const resize = () => {
            const header = document.getElementById("header_id");
            if (!header || !spaceRef.current) return;

            const height = header.offsetHeight;
            spaceRef.current.style.height = `${height}px`;
        };

        window.addEventListener("resize", resize);

        resize();
        scrollToTop();

        return () => {
            window.removeEventListener("resize", resize);
        };
    }, [scrollToTop]);

    return (
        <PageLayout>
            <div ref={spaceRef} />

            <MortgageCalculator/>

            <PrivateBrokerConsultation />
        </PageLayout>
    );
}
